export default "__VITE_ASSET__DaSIQ3f$__"